import {
  faFileAlt,
  faTags,
  faLink,
  faEyeSlash,
  faBookOpen,
  faCodeBranch,
  faCloudUploadAlt
} from "@fortawesome/free-solid-svg-icons";
import PluginInfo from "components/pluginInfo";
import PluginVer from "components/pluginVer";
import pluginUploadFiles from "components/pluginUploadFiles";
import historyVer from "components/historyVer"
import overtimeVer from "components/overtimeVer"
import Nav404 from "components/404";

const pages = {
  // 展示插件列表信息的路由
  pluginInfo: {
    index: 0,
    path: "/pluginInfo",
    basePath: "/pluginInfo",
    name: "插件列表",
    icon: faFileAlt,
    component: PluginInfo,
  },
  // 点击单个插件的时候展示插件详情的路由
  pluginVer: {
    index: 1,
    // path: "/pluginVer/:pluginName?",
    path: "/pluginVer",
    basePath: "/pluginVer",
    name: "插件详情",
    icon: faTags,
    component: PluginVer,
  },
  // verDep: {
  //   path: "/verDep",
  //   basePath: "/verDep",
  //   name: "版本依赖",
  //   icon: faLink,
  //   component: VerDep,
  // },
  // 当点击文件上传的时候展示多文件上传的页面路由
  pluginUpload: {
    path: '/pluginUploadFiles',
    basePath: '/pluginUploadFiles',
    name: "发布版本",
    icon: faCloudUploadAlt,
    component: pluginUploadFiles
  },
  // 已经发布的历史版本
  historyVer: {
    path: '/historyVer',
    basePath: '/historyVer',
    name: "历史版本",
    icon: faCloudUploadAlt,
    component: historyVer
  },
  overtimeVer: {
    path: '/overtimeVer',
    basePath: '/overtimeVer',
    name: "过期版本",
    icon: faCloudUploadAlt,
    component: overtimeVer
  },
  // 当访问不存在的路由的时候展示 404 页面
  page404: {
    path: "/404",
    basePath: "/404",
    name: "404",
    icon: faEyeSlash,
    component: Nav404,
  },
};

const pluginVerBasePath = pages.pluginVer.path;

// 插件列表的版本页面路由信息
const pluginVerPages = {
  detail: {
    basePath: `${pluginVerBasePath}/detail`,
    name: "Detail",
    icon: faBookOpen,
  },
  releases: {
    basePath: `${pluginVerBasePath}/releases`,
    name: "Releases",
    icon: faTags,
  },
  // dependency: {
  //   basePath: `${pluginVerBasePath}/dependency`,
  //   name: "Dependency",
  //   icon: faCodeBranch,
  // },
};

// 获取到所有的导航栏的项目信息的值 用于实现动态添加侧边导航
const barItems = Object.values(pages);
const pluginVerBarItems = Object.values(pluginVerPages);

const defaultPath = pages.pluginInfo.path;
const defaultPluginVerPath = pluginVerPages.detail.basePath;

const path404 = pages.page404.path;

export default {
  barItems,
  defaultPath,
  defaultPluginVerPath,
  pluginVerBasePath,
  path404,
  pages,
  pluginVerPages,
  pluginVerBarItems,
};
